import React from "react";
import {FrontlineCheckbox} from "../../../../Shared/FrontlineCheckbox";

export const RenderInput = ({settings}) => {

    return (
        <div className={`relative w-full max-w-${settings.length}`}>
            <input
                type={settings.type}
                className={`bg-transparent outline-none py-1 pr-5 w-full max-w-${settings.length}`}
                style={{ appearance: 'textfield', MozAppearance: 'textfield' }}
                placeholder={settings.placeholder}
                value={settings.value}
                onChange={settings.onChange}
                min={settings.type === 'number' ? 0 : 3}
                max={settings.type === 'number' ? settings.maxValue : 24}
                maxLength={settings.type !== 'text' ? settings.MaxLength : undefined}
                data-testid={`sub-ws-input-${settings.fieldInDb}`}
            />
            <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
                {settings.Icon}
            </div>
        </div>
    );
}

export const renderCheckbox = (settings) => {
    return (
        <div className="flex flex-row ml-4 gap-2 items-center">
            <div>{settings.title}</div>
            <FrontlineCheckbox isChecked={settings.value} onChange={settings.onChange}/>
        </div>
    )
}

